const LOGGER_CONFIG_LOCAL_STORAGE_NAME = 'loggingConfig'

const DEFAULT_CONFIG = {
  debug: {
    message: false,
    data: false,
    enableAllComponents: false,
    enabledComponents: [],
    // Examples of components:
    // 'LoginPage',
    // 'GatsbyBrowser',
    // 'RouteChangePubSub',
    // 'DistributionCalculatorPage',
    // 'DistributionCalculatorPage.AccountsTab',
    // 'Components.EditableTable'
    // 'LocalPersistence.Allocations',
    // 'Models.UiDistributionCalc',
  },
  log: { message: false, data: false },
  error: { message: true, data: true }
}

let loggingConfig = DEFAULT_CONFIG

function initLocalLoggingConfig() {
  localStorage.setItem(LOGGER_CONFIG_LOCAL_STORAGE_NAME, JSON.stringify(DEFAULT_CONFIG))
}

export function initLogger() {
  const loggingConfigRaw = localStorage.getItem(LOGGER_CONFIG_LOCAL_STORAGE_NAME)
  if (loggingConfigRaw) {
    try {
      loggingConfig = JSON.parse(loggingConfigRaw)
    } catch (e) {
      if (loggingConfig.error.message) {
        console.error('logger.initLogger failed', { e })
      }
      initLocalLoggingConfig()
    }
  } else {
    initLocalLoggingConfig()
  }
  if (loggingConfig.debug.message) {
    console.debug('[Logger] initLogger', { loggingConfig })
  }
}

export function getDebugLogger(component) {
  return (message, ...data) => {
    if ((loggingConfig.debug.enableAllComponents
         || loggingConfig.debug.enabledComponents.includes(component))) {
      if (loggingConfig.debug.data) {
        console.debug(`[${component}] ${message}`, ...data)
      } else if (loggingConfig.debug.message) {
        console.debug(`[${component}] ${message}`)
      }
    }
  }
}

// TODO: consider implementing getLogLogger
export function log(message, ...data) {
  if (loggingConfig.log.data) {
    console.log(message, ...data)
  } else if (loggingConfig.log.message) {
    console.log(message)
  } else {
    // do nothing
  }
}

// TODO: consider implementing getErrorLogger
export function error(message, ...data) {
  if (loggingConfig.error.data) {
    console.error(message, ...data)
  } else if (loggingConfig.error.message) {
    console.error(message)
  } else {
    // do nothing
  }
}
